import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import CustomBoard from "../../../../components/CustomBoard";
import Color from "../../../../../utils/Color";
import "fontsource-muli";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomTextInputV2 from "../../../../components/CustomTextInputV2";
import CustomButton from "../../../../components/CustomButton";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../../../common/selectors";
import * as changePasswordSelector from "../../../../../common/selectors/auth";
import * as changePasswordAction from "../../../../../common/actions/auth";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import CustomToast from "../../../../components/CustomToast";
import AuthManager from "../../../../../utils/AuthManager";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Clear';
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";

const BlueOnGreenTooltip = withStyles({
  tooltip: {
    color: "#74788D",
    backgroundColor: "#FFEDB9",
    minWidth: "400px",
  },
  arrow: {
    fontSize: 25,
    width: "20px",
    color: "#FFEDB9",
    "&::before": {
      backgroundColor: "#FFEDB9",
      //border: "2px solid red"
    },
  },
})(Tooltip);

// Password strength regex helper
const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

class NewPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      height: 0,
      nric: "",
      otpReference: "",
      customToastStatus: false,
      toastMessage: "",
      newPasswordAction: false,
      localNric: "",
      localOtpRef: "",
      localResendOtpRef: "",
      localResendOtp: "",
      passwordTouched: false,
      confirmTouched: false,
      isPasswordValid: false,
      isMatch: true,
      showPassword: false,
      showConfirm: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    await AuthManager.retrieveNric().then((value) => {
      if (value) {
        this.setState({ localNric: value });
      }
    });
    await AuthManager.retrieveOtpReference().then((value) => {
      if (value) {
        this.setState({ localOtpRef: value });
      }
    });
    await AuthManager.retrieveResendOtpReference().then((value) => {
      if (value) {
        this.setState({ localResendOtpRef: value });
      }
    });
    await AuthManager.retrieveResendOtp().then((value) => {
      if (value) {
        this.setState({ localResendOtp: value });
      }
    });

  
    // const {
    //   nric,
    //   otpReference,
    //   resendOtpReference,
    //   resendOtp,
    // } = this.props.location.state;

    // if (this.state.localResendOtp === false) {
    //   this.setState({nric:nric});
    //   this.setState({otpReference:otpReference});
    // } else {
    //   this.setState({nric:nric});
    //   this.setState({otpReference:resendOtpReference});
    // }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    // AuthManager.removeNric();
    // AuthManager.removeReference();
    // AuthManager.removeResendOtpReference();
    // AuthManager.removeResendOtp();
  }

  componentDidUpdate() {
    const { changePasswordData, changePasswordLoading } = this.props;
    const IsSuccess = changePasswordSelector.changePasswordDataData(
      changePasswordData
    );

    if (
      changePasswordData === true &&
      changePasswordLoading === false &&
      this.state.newPasswordAction === true
    ) {
      const { history } = this.props;
      history.push("/ChangedPassword");
    } else if (
      changePasswordData !== true &&
      changePasswordLoading === false &&
      this.state.newPasswordAction === true
    ) {
      const msg = changePasswordSelector.changePasswordDataMessage(
        changePasswordData
      );
      this.setState({ customToastStatus: true });
      this.setState({
        toastMessage: msg,
      });
      this.setState({ newPasswordAction: false });
    }
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onChangeNewPassword = (event) => {
    const val = event.target.value;
    this.setState({ newPassword: val, passwordTouched: true, isPasswordValid: passwordRegex.test(val), isMatch: val === this.state.confirmPassword });
  };

  onChangeConfirmPassword = (event) => {
    const val = event.target.value;
    this.setState({ confirmPassword: val, confirmTouched: true, isMatch: val === this.state.newPassword });
  };

  onClickSubmit = () => {
    // const { history } = this.props;
    // history.push("/ChangedPassword");
    const { resendOtp, newPassword, confirmPassword } = this.state;
    const { changePasswordRequest } = this.props;
    if (newPassword !== confirmPassword) {
      this.setState({ customToastStatus: true });
      this.setState({
        toastMessage: "Passwords do not match.",
      });
      return;
    }

    if (this.state.localResendOtp === "false") {
      changePasswordRequest(
        this.state.localNric,
        this.state.newPassword,
        this.state.confirmPassword,
        this.state.localOtpRef
      );
    } else if (this.state.localResendOtp === "true") {
      changePasswordRequest(
        this.state.localNric,
        this.state.newPassword,
        this.state.confirmPassword,
        this.state.localResendOtpRef
      );
    }
    this.setState({ newPasswordAction: true });
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  handleClickShowPassword = () => { this.setState({ showPassword: !this.state.showPassword }); };
  handleClickShowConfirm = () => { this.setState({ showConfirm: !this.state.showConfirm }); };
  handleMouseDown = e => { e.preventDefault(); };

  renderTooltip = () => {
    const { classes } = this.props;
    return (
      <BlueOnGreenTooltip
        title={
          <div>
            <CustomText design={classes.tooltipTextStyle}>
              • Password should be at least 8 characters, comprise of upper and
              lower case alphanumeric.{" "}
            </CustomText>
            <CustomText design={classes.tooltipTextStyle}>
              • Password should not contain spaces.
            </CustomText>
            <CustomText design={classes.tooltipTextStyle}>
              • Password need to include special characters.
            </CustomText>
          </div>
        }
        placement="right"
        arrow
        style={{ marginTop: -3 }}
      >
        <HelpIcon className={classes.infoIconStyleV2} onClick={this.handleTooltipOpen} />
      </BlueOnGreenTooltip>
    );
  };

  renderChildren = () => {
    const { classes } = this.props;
    const { newPassword, confirmPassword } = this.state;
    return (
      <div>
        <CustomText design={classes.headerTextStyle}>
          Enter New Password
        </CustomText>
        <div className={classes.inputContainer}>
          <div>
            <CustomTextInput
              id="outlined-adornment-password"
              type={this.state.showPassword ? 'text' : 'password'}
              title={"New Password"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={newPassword}
              onChange={this.onChangeNewPassword}
              tooltip={this.renderTooltip()}
              error={this.state.passwordTouched && !this.state.isPasswordValid}
              //errorMessage={"Weak password"}
              endAdornment={(<IconButton aria-label="toggle" onClick={this.handleClickShowPassword} onMouseDown={this.handleMouseDown} edge="end">{this.state.showPassword ? <VisibilityOffOutlined style={{ color: '#171717' }}/>:<VisibilityOutlined style={{ color: '#171717' }}/>}</IconButton>)}
            />
          </div>

          {this.state.passwordTouched  && (
            <div style={{ marginBottom: 15, marginTop: this.state.isPasswordValid ? 10: 5 }}>
              <CustomText style={{ fontWeight:'bold', marginBottom:8 }}>Password requirements:</CustomText>
              <div>
                <div style={{ display:'flex', alignItems:'center', marginTop:4 }}>
                  {newPassword.length >= 8 ? <CheckIcon style={{color:'#10B981',fontSize:16,marginRight:4}}/> : <CancelIcon style={{color:'#EF4444',fontSize:16,marginRight:4}}/>}
                  <CustomText style={{ color:newPassword.length>=8?'#10B981':'#EF4444',fontWeight:'400' }}>Minimum 8 characters</CustomText>
                </div>
                <div style={{ display:'flex', alignItems:'center', marginTop:4 }}>
                  {/[A-Z]/.test(newPassword) ? <CheckIcon style={{color:'#10B981',fontSize:16,marginRight:4}}/> : <CancelIcon style={{color:'#EF4444',fontSize:16,marginRight:4}}/>}
                  <CustomText style={{ color:/[A-Z]/.test(newPassword)?'#10B981':'#EF4444',fontWeight:'400' }}>At least 1 uppercase</CustomText>
                </div>
                <div style={{ display:'flex', alignItems:'center', marginTop:4 }}>
                  {/[a-z]/.test(newPassword) ? <CheckIcon style={{color:'#10B981',fontSize:16,marginRight:4}}/> : <CancelIcon style={{color:'#EF4444',fontSize:16,marginRight:4}}/>}
                  <CustomText style={{ color:/[a-z]/.test(newPassword)?'#10B981':'#EF4444',fontWeight:'400' }}>At least 1 lowercase</CustomText>
                </div>
                <div style={{ display:'flex', alignItems:'center', marginTop:4 }}>
                  {/\d/.test(newPassword) ? <CheckIcon style={{color:'#10B981',fontSize:16,marginRight:4}}/> : <CancelIcon style={{color:'#EF4444',fontSize:16,marginRight:4}}/>}
                  <CustomText style={{ color:/\d/.test(newPassword)?'#10B981':'#EF4444',fontWeight:'400' }}>At least 1 number</CustomText>
                </div>
                <div style={{ display:'flex', alignItems:'center', marginTop:4 }}>
                  {/[^A-Za-z0-9]/.test(newPassword) ? <CheckIcon style={{color:'#10B981',fontSize:16,marginRight:4}}/> : <CancelIcon style={{color:'#EF4444',fontSize:16,marginRight:4}}/>}
                  <CustomText style={{ color:/[^A-Za-z0-9]/.test(newPassword)?'#10B981':'#EF4444',fontWeight:'400' }}>At least 1 special character</CustomText>
                </div>
              </div>
            </div>
          )}

          <div style={{ marginTop: 25 }}>
            <CustomTextInput
              id="outlined-adornment-password"
              type={this.state.showConfirm ? 'text':'password'}
              title={"Confirm Password"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={confirmPassword}
              onChange={this.onChangeConfirmPassword}
              error={this.state.confirmTouched && !this.state.isMatch}
              errorMessage={!confirmPassword ? "Please confirm your password." : "Passwords do not match."}
              endAdornment={(<IconButton aria-label="toggle" onClick={this.handleClickShowConfirm} onMouseDown={this.handleMouseDown} edge="end">{this.state.showConfirm?<VisibilityOffOutlined style={{ color: '#171717' }}/>:<VisibilityOutlined style={{ color: '#171717' }}/>}</IconButton>)}
            />
          </div>
        </div>

        <CustomButton
          title={"Confirm"}
          design={classes.buttonStyle}
          onClick={this.onClickSubmit}
        />
      </div>
    );
  };

  render() {
    const { classes, changePasswordLoading } = this.props;
    const { height } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard children={this.renderChildren()} height={height} />
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
        {changePasswordLoading ? <LoadingOverlay loading={true} /> : false}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#171717"
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: "#171717"
  },
  textInputContainer: {
    height: 40,
    marginTop: 5,
  },
  inputContainer: {
    marginTop: 40,
  },
  buttonStyle: {
    // width: 120,
    marginTop: 30,
    height:'48px'
  },
  tooltipTextStyle: {
    color: "#74788D",
    //opacity: 0.45,
    fontSize: "12px",
    fontWeight: "400",
    padding: 2,
    lineHeight: 1.6,
    paddingLeft: 5,
    position: "relative",
    //background:"red"
  },
  arrow: {
    fontSize: 25,
    width: "20px",
    color: "#FFEDB9",
    "&::before": {
      backgroundColor: "#FFEDB9",
      //border: "2px solid red"
    },
  },
  infoIconStyle: {
    width: "20x",
    height: "20px",
    color: "#00B4AF",
    marginLeft: 10,
  },
  infoIconStyleV2: {
    width: "20x",
    height: "20px",
    color: "#FEC31A",
    marginLeft: 10,
  },
  bulletStyle: {
    position: "absolute",
    left: "-40px",
    top: "50%",
    transform: "translate(0%,-50%)",
    fontWeight: "bold",
  },
});

function mapStateToProps(state) {
  return {
    changePasswordData: selector.changePasswordData(state),
    changePasswordLoading: selector.changePasswordLoading(state),
    changePasswordStatus: selector.changePasswordStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changePasswordRequest: (userID, password, confirmPassword, otpReference) =>
      dispatch(
        changePasswordAction.changePasswordRequest(
          userID,
          password,
          confirmPassword,
          otpReference
        )
      ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(NewPassword)));
